import { lazy } from "react";
// project import
import Loadable from "components/Loadable";

// ==============================|| ROUTES ITEMS - MANAGED ASSETS ||============================== //

const ManagedAssetsDefault = Loadable(
    lazy(() => import("pages/nostradamus/managed-assets/ManagedAssetsPage"))
);

const managed_assets = {
    path: "managed-assets",
    element: (
        <ManagedAssetsDefault />
    ),
};

export default managed_assets;
